import { NavLink } from 'react-router-dom';
import { SCREENS } from './screens';

/** The buyer's name and its reference screens, with the current one marked. */
export default function BuyerNav({ slug, buyerName }: { slug: string; buyerName: string }) {
  return (
    <div className="border-b border-line">
      <p className="text-caption font-semibold text-ink-muted">{buyerName}</p>
      <nav aria-label="Reference data" className="-mb-px mt-2 flex gap-6 overflow-x-auto">
        {SCREENS.map((s) => (
          <NavLink
            key={s.path}
            to={`/buyers/${slug}/${s.path}`}
            className={({ isActive }) =>
              `border-b-2 pb-2 text-body transition-colors ${
                isActive ? 'border-navy font-semibold text-navy' : 'border-transparent text-ink-muted hover:text-ink'
              }`
            }
          >
            {s.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
